import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ClientTokenModel} from '../../models/clients/client.token.model';
import { ConfigService } from '../config/config.service';

export class BaseClientService {
  clientTokenEvent: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  protected readonly baseUrlApi = this.configService.config.urlApi;

  constructor(protected client: HttpClient, private configService: ConfigService) {}

  setClientToken(clientToken: string): void {
    this.clientTokenEvent.next(clientToken);
  }

  loadClientToken(): Observable<ClientTokenModel> {
    return this.client.get<ClientTokenModel>(`${this.baseUrlApi}/api/c/clients/token`);
  }
}
